import Button from 'components/Button';
import { FC } from 'react';
import { Link, Route, Routes } from 'react-router-dom';

const MentorshipManagementButtonsRoutes: FC = () => {
  return (
    <Routes>
      <Route
        path="/interviews"
        element={
          <Link to="suggest">
            <Button color="primary">Nouvel entretien</Button>
          </Link>
        }
      />
    </Routes>
  );
};

export default MentorshipManagementButtonsRoutes;
